import { getSmoothCoords } from '../utils/dronePathUtils';

export const DRONE_DEMO_GEOJSON = {
  type: 'Feature' as const,
  geometry: {
    type: 'LineString' as const,
    coordinates: getSmoothCoords(),
  },
  properties: {},
};
